import { getAxios } from '@/utils/Utils'

import API from '@/utils/ApiConfig'

export default {
  saveBasic: (firstName, lastName, email, username) => getAxios().patch(API.SERVER + API.PROFILE_PATCH, { firstName, lastName, email, username })
    .then((res) => {
      // TODO: Implement
      // Save new user data
      // store.dispatch('updateUser', { res.data.data })
      return res.data
    }),

  savePassword: (password) => getAxios().patch(API.SERVER + API.PROFILE_PATCH, { password })
    .then(res => res.data),

  updateProfileThumbnail: (thumb) => getAxios().patch(API.SERVER + API.PROFILE_PATCH, { thumb })
    .then((res) => res.data).catch(err => { throw err })
}



// WEBPACK FOOTER //
// ./src/services/ProfileService.js